import React from 'react';
import { currency } from 'App/config';
export default function CartTotalRow(_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, label = _a.label, _c = _a.last, last = _c === void 0 ? false : _c, value = _a.value;
    return (React.createElement("div", { className: "cart-total__row ".concat(last ? 'cart-total__row--last' : '', " ").concat(className) },
        React.createElement("span", { className: "cart-total__label" },
            label,
            ":"),
        React.createElement("span", { className: "cart-total__value" },
            value,
            " ",
            currency)));
}
